import { Component, effect, DestroyRef, inject, OnInit, signal, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatTableModule } from '@angular/material/table';
import { ContractService } from '../../core/services/contract.service';
import { CurrencyPipe } from '@angular/common';
import { Router } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';


@Component({
  selector: 'app-cart',
  imports: [CommonModule,
    MatTableModule,
    CurrencyPipe,
    MatIconModule],
  templateUrl: './cart.component.html',
  styleUrl: './cart.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: true
})
export class CartComponent implements OnInit {
  contractService: ContractService = inject(ContractService);
  selected: any[] = [];
  displayedColumns: string[] = ['position', 'sku', 'name', 'once', 'monthly', 'actions'];

  private router: Router = inject(Router);

  constructor() {
    this.loadCart();
    console.log('start cart: ' + this.selected);
    effect(() => {

      this.contractService.cartChanged();
      this.loadCart();
    });
  }

  ngOnInit() {
    // this.loadCart();
  }

  loadCart() {
    // this.selected = this.contractService.selectedContracts();

    const sel = sessionStorage.getItem('selectedContracts');
    if (sel) {
      this.selected = JSON.parse(sel);
    } else {
      this.selected = [];
    }
  }

  totalOnce() {
    let once = 0;
    this.selected.forEach((contract) => {
      once += Number(contract.price) || 0;
    })
    return once;
  }

  totalMonthly() {
    let monthly = 0;
    this.selected.forEach((contract) => {
      monthly += Number(contract.monthly) || 0;
    })
    return monthly;
  }

  remove(element: any) {
    this.selected = this.selected.filter((f) => f !== element)
    sessionStorage.setItem('selectedContracts', JSON.stringify(this.selected));
    this.contractService.selectedContracts.set(this.selected);
    this.contractService.cartChanged.update(version => version + 1);
  }

  save() {

  }

  sign() {
    this.router.navigate(['/signature']);
  }
}
